<template>
  <div style="width: 100%; height: 100%">
    <div class="diagram">
      <div class="fullbtn">
        <div class="btn row-center" v-if="!isFull" @click="full">
          <img src="@/assets/img/切换全屏ICON.png" style="margin-right:4px;" alt="切换全屏" />
          <span>切换全屏</span>
        </div>
      </div>
      <div class="content">
        <div class="body">
          <Diagram
            ref="Diagram"
            :src="currentWireURL"
            :isFull="isFull"
            @onCancelFull="onCancelFull"
          ></Diagram>
        </div>
      </div>
      <div class="content-bg"></div>
    </div>
  </div>
</template>

<script>
import Diagram from "@/components/Diagram";

export default {
  name: "FirstDiagram",
  components: {
    Diagram,
  },
  data() {
    return {
      currentWireURL: "http://local.vrmaker.vip:38080/wiring/lcy-1.html",
      isFull: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    full() {
      this.isFull = true;
      this.$refs.Diagram.full();
    },
    onCancelFull() {
      this.isFull = false;
    },
    cancelFull() {
      this.$refs.Diagram.cancelFull();
    },
  },
};
</script>

<style lang="less" scoped>
.diagram {
  margin: auto;
}
.content {
  width: 1394px;
  height: 712px;
  display: flex;
  padding-left: 0;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-image: url(../assets/img/diagram-bg.png);

  .header {
    width: 1600px;
    height: 96px;
    background: #ffffff;
    box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);
  }

  .body {
    margin: 35px 0 0;
    width: 1344px;
    height: 652px;
    background: #eee;
    position: relative;
  }

  .pagination {
    height: 6vh;
    width: 300px;
    align-self: flex-end;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    font-size: 14rem;

    .button {
      width: 74px;
      height: 24px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 2px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.fullbtn {
  z-index: 9999;
  display: flex;
  // justify-content: center;
  // align-items: center;
  .btn {
    width: 150px;
    height: 56px;
    position: absolute;
    top: 14px;
    // right: 36px;
    left: 1254px;
    z-index: 9999;
    background-image: url(../assets/img/diagrambtn-bg.png);
    // text-align: center;
    // padding: 17px;
    color: #333333;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    img {
      // .wh(16, 16);
      // width: @w;
      // height: @h;
      width: 16px;
      height: 16px;
      margin-right: 7 / 1920 * 100vw;
      margin-top: -1px;
    }
  }
}
.content-bg {
  width: 1394px;
  height: 49px;
  background-image: url(../assets/img/倒影.png);
}

.tip {
  width: 100%;
  height: 100%;
  font-size: 16rem;
  color: #8c939d;
}

.loading {
  width: 28rem;
  height: 28rem;
  animation: loading 1s linear infinite;
}

@keyframes loading {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>